import {HydraService} from './../../core/services/hydra.service';
import {AuthentificationService} from './../../core/services/authentification.service';
import {Aide} from './../../class/api/Aide';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Component, OnInit, inject } from '@angular/core';
import {TranslationService} from '../services/translation.service';
import {ToolsService} from '../services/tools/tools.service';
import { DatePipe } from '@angular/common';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../pipes/safeHtml.pipe';

@Component({
    selector: 'app-modal-info-details-aide',
    template: `
        <h6 matDialogTitle>
          {{ aide?.label }}
        </h6>
        
        @if (aide) {
          <mat-dialog-content>
            <span  class="ouvrirDossiereDates">
              {{ 'front.dossiersListe.inscriptionDu' | translate }}
              <span class="bold">{{aide?.dateDebutSaisie | date: "dd/MM/y"}}</span>
              {{ 'front.dossiersListe.au' | translate }}
              <span class="bold">{{aide?.dateFinSaisie | date: "dd/MM/y"}}</span>
            </span>
            <hr>
              <div class="row"  style="max-height:503px; overflow-y:auto; padding-bottom: 15px;">
                <div class="col">
                  <h5>{{ 'front.dossiersListe.commentaire' | translate }}</h5>
                  <div class="zoneInfo"
                    [innerHTML]="getLabel('commentaire', aide) | safeHtml"
                  ></div>
                  <h5>{{ 'front.dossiersListe.preRequis' | translate }}</h5>
                  <div class="zoneInfo" [innerHTML]="getLabel('preRequis', aide) | safeHtml"></div>
                  @if (getLabel('notice', aide)) {
                    <div>
                      <h5>{{ 'general.notice' | translate }}</h5>
                      <div class="zoneInfo">
                        <button
                          mat-raised-button
                          color="secondary"
                          (click)="downloadAnnexe(getLabel('notice', aide))"  tabindex="-1"
                          >
                          <mat-icon class="mat-icon">redo</mat-icon>
                          {{ 'general.telechargerNotice' | translate }}
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </mat-dialog-content>
          }
        
          @if (!noValidation) {
            <mat-dialog-actions>
              <mat-checkbox style="margin-left:15px; color:#fff"   [(ngModel)]="selected">{{ 'generale.luApprouvePrerequis' | translate }}</mat-checkbox>
              <button mat-raised-button [disabled]="!selected" color="primary" (click)="close()">
                {{ 'general.remplirCeDossier' | translate }}
              </button>
            </mat-dialog-actions>
          }
          @if (noValidation) {
            <mat-dialog-actions>
              <button mat-button  (click)="close()">
                {{ 'general.close' | translate }}
              </button>
            </mat-dialog-actions>
          }
        
        `,
    styleUrls: ['./modal-info-details-aide.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatButton, MatIcon, MatDialogActions, MatCheckbox, FormsModule, DatePipe, TranslateModule, SafeHtmlPipe]
})
export class ModalInfoDetailsAideComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalInfoDetailsAideComponent>>(MatDialogRef);
    data = inject<{
    aide;
    candidatures;
    noValidation;
}>(MAT_DIALOG_DATA);
    translationService = inject(TranslationService);
    authService = inject(AuthentificationService);
    private toolService = inject(ToolsService);
    private hydraService = inject(HydraService);

    public selected = false;
    aide: Aide = null;
    public noValidation = false;

    constructor() {
        this.aide = this.data.aide;
        if(this.data['noValidation']){
            this.noValidation = this.data.noValidation;
        }
    }

    public getLabel(key, aide) {
        let str = '';
        // TODO en attente un Patch de Betrand, ajouter aide.translations dans l'api candidatures dossiers[x].aide.translations[]
        if(!aide.translations){
            return '';
        }
        else{
            aide.translations.map(item => {
                if (item.locale == this.authService.userConnected.locale) {
                    str = item[key];
                }
            });
            return str;
        }
    }

    downloadAnnexe(item) {
        this.toolService.download(item);
    }

    public close() {
        this.dialogRef.close(true);
    }

    ngOnInit() {}
}
